'use client'

import { UseAccessibleOverlayReturn, useAccessibleOverlay } from '../../../../hooks/useAccessibleOverlay'
import React, { createContext, useCallback, useMemo, useState, useId } from 'react'

export interface MainNavigationListItemContextValue {
    isOpen: boolean
    toggle: () => void
    close: () => void
    overlay: UseAccessibleOverlayReturn
}

export const MainNavigationListItemContext = createContext<MainNavigationListItemContextValue | null>(null)

interface Props {
    children: React.ReactNode
}

export const MainNavigationListItemProvider = ({ children }: Props) => {
    const [isOpen, setIsOpen] = useState(false)
    const reactId = useId()
    const contentId = `${reactId}-overlay-content`

    const toggle = useCallback(() => {
        setIsOpen((previous) => !previous)
    }, [])

    const close = useCallback(() => {
        setIsOpen(false)
    }, [])

    const overlay = useAccessibleOverlay({
        isOpen,
        contentId,
        trapFocus: true,
        role: 'dialog',
        ariaModal: false,
    })

    const value = useMemo<MainNavigationListItemContextValue>(
        () => ({
            isOpen,
            toggle,
            close,
            overlay,
        }),
        [isOpen, toggle, close, overlay],
    )

    return <MainNavigationListItemContext.Provider value={value}>{children}</MainNavigationListItemContext.Provider>
}
